import { type JsonLd } from '@atlaskit/json-ld-types';

import type { URLMetaData } from '../../common/types/url/types';

let urlResolverService: UrlResolverService | undefined;

export function getUrlResolverService(): UrlResolverService {
	if (urlResolverService) {
		return urlResolverService;
	}
	urlResolverService = new UrlResolverService();
	return urlResolverService;
}

function mapJsonLdToURLMetaData(response: JsonLd.Response): URLMetaData {
	const data = response.data as JsonLd.Data.BaseData | undefined;
	return {
		url: (data?.url as string) ?? '',
		title: data?.name ?? '',
	};
}

export class UrlResolverService {
	async resolve(url: string): Promise<URLMetaData> {
		// TODO: Implement actual URL resolution logic
		// This is a placeholder implementation
		const response: JsonLd.Response = {
			meta: {
				access: 'granted',
				visibility: 'restricted',
				resourceType: 'page',
				objectId: '',
				tenantId: '',
				containerId: '',
				category: 'object',
				auth: [],
				definitionId: '',
				product: 'confluence',
			},
			data: {
				'@context': {
					'@vocab': 'https://www.w3.org/ns/activitystreams#',
					atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
					schema: 'http://schema.org/',
				},
				'@type': 'Document',
				url,
				name: 'Sample mock page',
				summary: '',
				updated: '',
				'schema:dateCreated': '',
				attributedTo: {
					name: '',
					icon: '',
					'@type': 'Person',
				},
				generator: {
					'@type': 'Application',
					'@id': '',
					name: '',
					icon: {
						'@type': 'Image',
						url: '',
					},
				},
				preview: {
					'@type': 'Link',
					href: '',
				},
			},
		};

		return mapJsonLdToURLMetaData(response);
	}
}
